// Generated types for SystemPrompt
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { IslandRootReadAPI, IslandRootWriteAPI } from '../../shared/types/islandroot';
import { IslandRootReadAPISchemaObject, IslandRootWriteAPISchemaObject } from '../../shared/types/islandroot';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SystemPromptReadAPI extends Omit<IslandRootReadAPI, 'created_at'> {
  /** When prompt was created */
  created_at?: string | null;
  /** The system prompt content */
  content: string;
  /** sha256[:16] of content — deduplication key, NOT the id */
  content_hash?: string | null;
}

export interface SystemPromptWriteAPI extends IslandRootWriteAPI {
  /** The system prompt content */
  content: string;
  /** sha256[:16] of content — deduplication key, NOT the id */
  content_hash?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SystemPromptReadAPISchema: z.ZodType<SystemPromptReadAPI> = IslandRootReadAPISchemaObject.omit({ 'created_at': true }).extend({
  created_at: z.string().nullable().optional(),
  content: z.string(),
  content_hash: z.string().nullable().optional(),
}).passthrough();

export const SystemPromptWriteAPISchema: z.ZodType<SystemPromptWriteAPI> = IslandRootWriteAPISchemaObject.extend({
  content: z.string(),
  content_hash: z.string().nullable().optional(),
}).passthrough();
